import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

import shopsBanner from '../../../../assets/img/promosEventsBanner.webp'
import ZingIcon from '../../../../assets/img/zing-icon.svg'

import CatalogList from '../../../../components/home/CatalogList/CatalogList'
// import TextInput from '../../../../components/ui/TextInput/TextInput'
import LinkButton from '../../../../components/ui/LinkButton/LinkButton'

//(Link)
export const StyledLink = styled.div`
  text-decoration: none;
  width: calc(33% - 1rem);
  height: 300px;
  margin: 0.5rem;
  cursor: pointer;

  ${media.lessThan('small')`
    width: calc(100% - 1rem);
    height: 100px;
    margin: 0.5rem;
    box-sizing: border-box;
    padding: 0px;
  `}
`

export const ErrorCard = styled.div`
  width: calc(33% - 1rem);
  height: 300px;
  margin: 0.5rem;

  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;
  border-radius: var(--border-radius-card);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledBanner = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(
      to bottom right,
      rgba(231, 71, 94, 0.90) 0%,
      rgba(235, 118, 50, 0.90) 100%
    ), url('${
      props && props.image && props.image.url ? props.image.url : shopsBanner
    }') top / cover no-repeat`,
    backgroundPosition: '37.5%',
  },
}))`
  width: 100%;
  height: 530px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 8, 0) 0%, #000000 158px);

  ${media.lessThan('small')`
    height: 450px;
    margin-top: -40px;
  `}
`

export const BannerContent = styled.div`
  width: 100%;
  max-width: 1024px;
  height: 430px;
  margin: 0 auto;

  display: flex;
  align-items: center;
`

export const BannerDescription = styled.div`
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #ffffff;
`

export const Heading = styled.div`
  /* margin-top:  !important; */
  ${media.lessThan('large')`
    padding: 0 1.5rem;
  `}

  ${media.lessThan('small')`
    padding: 0 1rem;
  `}
`

export const Content = styled.div`
  margin-top: 2.5rem;
  ${media.between('small', 'medium')`
   margin-left: 3rem;
   margin-right: 3rem;
  `}
`

export const FormContainer = styled.div`
  display: flex;
  margin-top: -6rem;
  width: 99%;
  margin: auto 0;
  ${media.lessThan('small')`
    width: 100%;
    /* margin: 1rem; */
    flex-wrap: wrap;
    margin-top: -2rem;
    padding: 1rem;
  `}
`

export const StyledCatalogList = styled(CatalogList)`
  ${media.lessThan('large')`
    margin: 0 1rem;
    justify-content: space-around;
  `}

  ${media.lessThan('small')`
    flex-direction: column;
    color: unset;
    padding: 0;
    justify-content: space-between;
    margin: 1rem;
  `}
`

export const RewardsCatalogTitle = styled.h2`
  font-size: 2rem;
  margin: 0;
  text-transform: uppercase;
  text-align: center;

  ${media.lessThan('small')`
    font-size: 1.375rem;
  `}
`
export const StyledShopDineCard = styled.div`
  border-radius: var(--border-radius-card);
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.8)),
    linear-gradient(rgba(141, 122, 157, 0.4), rgba(141, 122, 157, 0.4)),
    linear-gradient(#000000, #000000);
  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.cardImageUrl &&
    css`
      background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
      backgroundSize: 'cover';
      backgroundPosition: 'center';
    `}

  ${media.lessThan('small')`
    display: block;
    background: unset;
    background-color: #fff;
  `}
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 2.5rem;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  text-align: center;
  z-index: 1;

  ${media.lessThan('small')`
    flex-direction: row;
    padding: 0;
    align-items: center;
    height: 100px;
    box-sizing: border-box;
    overflow: hidden;
  `}
`

export const LogoContainer = styled.div`
  ${media.lessThan('small')`
    width: 100px;
    padding: 0px;
    /* margin: 0; */
    margin-left: -1rem;

    ${props =>
      props.cardImageUrl &&
      css`
        background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
        backgroundSize: 'cover';
        backgroundPosition: 'center';
        border-top-left-radius: 0.3125rem;
        border-bottom-left-radius: 0.3125rem;
      `}
  `}
`

export const Logo = styled.img`
  border: 0px;
  border-radius: 0.3125rem;
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  object-fit: contain;

  ${props =>
    props.src == null &&
    css`
      background-color: #000;
      border: 0px;
    `}

    ${media.lessThan('medium')`
    margin: 1rem auto;
  `}
  ${media.lessThan('small')`
    padding: auto;
    box-sizing: border-box;
    /* margin: auto; */
  `}
`

export const LogoFiller = styled.div`
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  background-color: transparent;
  ${media.lessThan('medium')`
  margin: 1rem auto;
`}
`

export const Title = styled.h1`
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0.28px;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.28px;
  margin: 0;
  text-transform: uppercase;

  ${media.lessThan('small')`
    width: calc(100% - 100px - 1rem);
    text-align: left;
    color: var(--color-fg);
    padding-left: 1rem;
    box-sizing: border-box;
  `}
`

export const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;

  ${media.lessThan('small')`
    flex: 0 0 auto;
    padding: 1.25rem;
    margin-bottom: 0;
  `}
`

export const SelectMallContainer = styled.div`
  padding-top: 0.5rem;
  margin-right: 1rem;
  // width: 50%;
  width: calc(50% - 1.5rem);
  color: #fff !important;

  ${media.lessThan('medium')`
    width:100%;
    margin-right:initial;
`}
`
export const ViewAll = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-right: 0.5rem;

  h3 {
    font-weight: 600;
    color: var(--color-primary);
  }

  ${media.lessThan('large')`
    margin: 1rem;
  `}
`

export const ViewAllLinkButton = styled(LinkButton)`
  height: 2.25rem;
  font-size: 0.75rem;
  padding: 0.5rem 1rem;
  background-color: var(--color-primary);
  color: var(--color-bg-form) !important;
  border: 0px;

  &:hover {
    background-color: var(--color-primary);
  }
`

export const SelectMallButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #4a4a4a;
  background: transparent;
  height: 3rem;
  // border: 0.5px solid #4a4a4a87;
  border: var(--border-form);
  border-radius: 4px;
  color: #4a4a4a;
  padding: 0 1rem;
  width: calc(50% - 1rem);
  margin-right: 1rem;
  margin-top: 0.5rem;

  &:focus {
    outline-color: none;
    border-color: var(--color-primary);
  }

  ${media.lessThan('medium')`
  width: calc(100% - 1rem);
  `}
  ${media.lessThan('small')`
    width: 100%;
    margin-right:0;
  `}
`

export const StyledTextInput = styled(LinkButton)`
  /* background-color: white;
  border: none !important; */

  &::placeholder {
    opacity: 1;
    color: #fff;
  }

  ${media.lessThan('medium')`
    opacity: 80%;
  `}

  ${media.lessThan('small')`
    padding-left: 0;
  `}
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  flex: 2;
  background-color: transparent;
  border: var(--border-form);
  border-radius: var(--border-radius-form);
  // box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05);
  color: #4a4a4a;
  margin-top: 0.5rem;

  &:focus {
    border-color: var(--color-primary);
  }

  ${media.lessThan('medium')`
    flex: unset;
    width: 100%;
    margin-left: 0px;
    /* width: calc(50% - 1.5rem) !important; */
    transition: all var(--animation-duration) var(--animation-easing);
    height: 3rem;
    margin-top: 0.5rem;

    &:hover {
      /* flex: 1; */
      /* width: calc(50% - 1.5rem) !important; */
      transition: all var(--animation-duration) var(--animation-easing);

      ${StyledTextInput} {
        /* padding-left: 1rem; */
      }
    }
  `}
`
export const TabItem = styled.span`
  flex: 1;
  color: white;
  font-family: var(--font-family-base);
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px;
  text-align: center;
  ${({ selected }) => (selected ? 'border-bottom: solid 4px white;' : '')}
`

export const TabContainer = styled.div`
  display: flex;
  margin: 0 12.5rem;
  height: 4rem;
  span:after {
    content: '';
    display: block;
    margin: auto;
    height: 3px;
    width: 0px;
    background: transparent;
    transition: width 0.5s ease, background-color 0.5s ease;
  }

  ${media.lessThan('medium')`
  margin: 0 5rem;
  span{
    padding: 2px;
  }
  `}
  ${media.lessThan('small')`
  margin:0;
  span{
    padding: 2px;
  }
  `}
`
